import { render, staticRenderFns } from "./DialogArchives.vue?vue&type=template&id=7a810c6e&scoped=true&"
import script from "./DialogArchives.vue?vue&type=script&lang=js&"
export * from "./DialogArchives.vue?vue&type=script&lang=js&"
import style0 from "./DialogArchives.vue?vue&type=style&index=0&id=7a810c6e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a810c6e",
  null
  
)

export default component.exports